// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfm_a bhl_wh bhl_sq bhl_xj"};